import { ConversationService } from '@forwardflow/services/ConversationService'
import useSWR from 'swr'

export function useDemoInboxAppEnabled(leadId: number | undefined) {
   const shouldFetch = typeof leadId === 'number' && !isNaN(leadId)
   const { data, error, isLoading, mutate } = useSWR(
      shouldFetch ? ['demo-inbox-app-enabled', leadId] : null,
      () => ConversationService.getDemoInboxAppEnabled(leadId as number)
   )

   return {
      data,
      error,
      isLoading,
      mutate,
   }
}
